module.exports = __webpack_public_path__ + "static/media/undraw_data-at-work_3tbf.8d78c373.svg";